module.exports = __webpack_public_path__ + "img/screenshot.275baa3b.png";